import {FIELD_TYPE} from "types/enums";
import {DataFormField} from "types/models/input-field-type";
const {INPUT, SELECT, DATE, COLOR} = FIELD_TYPE;
const css = { xs: 24, sm: 24, md: 24, lg: 8, xl: 8 };
const dataFields: DataFormField[] = [
  {
    type: INPUT,
    label: "Mã phòng",
    name: "maPhongBan",
    disable: false,
    rules: [{required: true, message: "Chưa nhập mã phòng ban"}],
    css:css,
    wrapperCol: { xs: 24,sm:14, md: 16, lg: 16, xl: 16 },
    labelCol: { xs: 24,sm:10, md: 8, lg: 8, xl: 8},
  },
  {
    type: INPUT,
    label: "Tên Phòng",
    name: "tenPhongBan",
    rules: [{required: true, message: "Chưa nhập tên phòng ban"}],
    css:css,
    wrapperCol: { xs: 24,sm:14, md: 16, lg: 16, xl: 16 },
    labelCol: { xs: 24,sm:10, md: 8, lg: 8, xl: 8},
  },
  {
    type: INPUT,
    label: "Ghi chú",
    name: "description",
    css:css,
    wrapperCol: { xs: 24,sm:14, md: 16, lg: 16, xl: 16 },
    labelCol: { xs: 24,sm:10, md: 8, lg: 8, xl: 8},
  },

];
export {dataFields};
